import React from 'react';

import * as Yup from 'yup';
import { Formik, Form, Field } from 'formik';
import { FormGroup, Label } from 'reactstrap';
import { ButtonWithLoadingIcon } from '../../../common/ButtonWithLoadingIcon';
import { Colxx } from '../../../common/CustomBootstrap';
import './shippingAdressEdit.scss';
// components

const FormInputWrapper = ({
  label,
  id,
  showError,
  error,
  children,
  ...other
}) => {
  return (
    <FormGroup>
      <Label className={'label-text'} for={id} {...other}>
        {label}
      </Label>
      <div>
        {children}
        {showError && (
          <div className='invalid-feedback d-block label-text'>{error}</div>
        )}
      </div>
    </FormGroup>
  );
};

const CommonFormInput = ({ label, name, id, type, showError, error }) => (
  <FormInputWrapper label={label} id={id} showError={showError} error={error}>
    <Field
      type={type}
      name={name}
      id={id}
      className='form-control label-text'
    />
  </FormInputWrapper>
);

// end of components

const profileEditSchema = Yup.object().shape({
  address: Yup.string().required('Please enter the adress'),
  city: Yup.string().required('Please enter the city'),
  state: Yup.string().required('Please enter the state'),
  zipcode: Yup.string().required('Please enter the zipcode'),
});

export const ShippingAddressEdit = ({
  shippingAddress,
  isUpdating,
  onSubmit,
}) => {
  const initialValues = {
    address: shippingAddress?.address ?? '',
    shipping_address: shippingAddress?.shipping_address ?? '',
    city: shippingAddress?.city ?? '',
    state: shippingAddress?.state ?? '',
    zipcode: shippingAddress?.zipcode ?? '',
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={profileEditSchema}
    >
      {({
        values,
        errors,
        isSubmitting,
        touched,
        setFieldValue,
        setFieldTouched,
      }) => {
        return (
          <Form className='mb-4'>
            <FormGroup row>
              <Colxx sm={12}>
                <CommonFormInput
                  label='Address'
                  type='text'
                  name='address'
                  id='ship-address'
                  showError={errors.address && touched.address}
                  error={errors.address}
                />
              </Colxx>
              
              <Colxx sm={12}>
                <CommonFormInput
                  label='Address Line 2(Optional)'
                  type='text'
                  name='shipping_address'
                  id='shipping_address'
                  // showError={errors.shipping_address && touched.shipping_address}
                  // error={errors.shipping_address}
                />
              </Colxx>

              <Colxx sm={12}>
                <CommonFormInput
                  label='City'
                  type='text'
                  name='city'
                  id='ship-cty'
                  showError={errors.city && touched.city}
                  error={errors.city}
                />
              </Colxx>

              <Colxx sm={12}>
                <CommonFormInput
                  label='State'
                  type='text'
                  name='state'
                  id='ship-state'
                  showError={errors.state && touched.state}
                  error={errors.state}
                />
              </Colxx>

              <Colxx sm={12}>
                <CommonFormInput
                  label='Zip code'
                  type='text'
                  name='zipcode'
                  id='profile-zipcode'
                  showError={errors.zipcode && touched.zipcode}
                  error={errors.zipcode}
                />
              </Colxx>
            </FormGroup>

            <FormGroup row>
              <Colxx sm={12} className='d-flex justify-content-center'>
                <ButtonWithLoadingIcon
                  disabled={isUpdating}
                  type='submit'
                  loading={isUpdating}
                  color='primary'
                  size='sm'
                  height={36}
                  className={'px-5'}
                >
                  UPDATE
                </ButtonWithLoadingIcon>
              </Colxx>
            </FormGroup>
          </Form>
        );
      }}
    </Formik>
  );
};
